<div class="sac" [style.--c]="subject.color">
  <header class="sac__head">
    <span class="sac__name">
      {{ subject.i18nKey ? (subject.i18nKey | translate) : subject.name }}
    </span>
    <span class="sac__head-right">
      @if (showFavorite) {
        <button type="button"
                class="sac__fav"
                [class.is-on]="isFavorite"
                (click)="toggleFavorite($event)"
                [attr.aria-pressed]="isFavorite"
                [attr.aria-label]="(isFavorite ? 'SUBJECTS.UNFAVORITE' : 'SUBJECTS.FAVORITE') | translate"
                [title]="(isFavorite ? 'SUBJECTS.UNFAVORITE' : 'SUBJECTS.FAVORITE') | translate">
          <i [class]="isFavorite ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
        </button>
      }
      <!-- Pastille d'icône rendue seulement si l'appelant en fournit une : les
           matières n'en portent pas, et la base stocke des noms Material
           Symbols qu'aucune police chargée ici ne sait afficher. -->
      @if (subject.icon) {
        <span class="sac__icon">
          <i [class]="subject.icon"></i>
        </span>
      }
    </span>
  </header>

  <div class="sac__progress" *ngIf="subject.progress != null">
    <span [style.width.%]="subject.progress"></span>
  </div>

  <div class="sac__actions">
    <a *ngIf="showExams"
       class="sac__btn sac__btn--exams"
       [routerLink]="examsLink"
       [queryParams]="resolvedQueryParams">
      <i [class]="examsIcon"></i>
      {{ examsLabelKey | translate }}
      <span class="sac__badge" *ngIf="examsBadge">{{ examsBadge }}</span>
    </a>
    <a *ngIf="showHomework"
       class="sac__btn sac__btn--homework"
       [routerLink]="homeworkLink"
       [queryParams]="resolvedQueryParams">
      <i [class]="homeworkIcon"></i>
      {{ homeworkLabelKey | translate }}
      <span class="sac__badge" *ngIf="homeworkBadge">{{ homeworkBadge }}</span>
    </a>
  </div>
</div>
